import * as accountsApi from '@/network/api/accounts.api.js'

/** Fetch Accounts List
@return { promise } - accounts list request
*/
export const accountsListFetch = async (context, payload) => {
    const res = await accountsApi.accounts(payload)

    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_LIST', data)
    }
    return res
}

/** Change the Default Account
@return { promise }
*/
export const changeDefaultAccount = async (context, payload) => {
    const res = await accountsApi.accountsDefault(payload)
    return res
}

/** Change the Visibility Account
@return { promise }
*/
export const changeAccountVisibility = async (context, payload) => {
    const res = await accountsApi.accountsVisible(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVES_NEW_ACCOUNT_VISIBILITY', data)
    }
    return res
}
